import React from "react";
import { ResourceCardsSkeleton } from "@/modules/hub/features/ResourceLibrary/components/ResourceCardsSkeleton/ResourceCardsSkeleton";
import { FilterSidebarSkeleton } from "@/modules/hub/features/ResourceLibrary/components/FilterSidebar/FilterSidebar/FilterSidebarSkeleton";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import MobileFilterToggleButton from "../MobileFilterToggleButton/MobileFilterToggleButton";
import { useIsMobile } from "@/hooks/use-mobile";

export function ResourcesLibrarySkeleton() {
  const isMobile = useIsMobile();

  const FeaturedResourcesSkeleton = () => (
    <div className="mb-8 p-6 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-950 dark:to-indigo-950 rounded-xl">
      <div className="animate-pulse">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <div className="h-6 w-6 bg-yellow-400 rounded"></div>
            <div className="h-8 w-48 bg-gray-200 dark:bg-gray-700 rounded"></div>
          </div>
          {!isMobile && (
            <div className="flex gap-2">
              <div className="h-10 w-10 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
              <div className="h-10 w-10 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
            </div>
          )}
        </div>

        <div
          className={`grid grid-cols-1 ${!isMobile ? "md:grid-cols-3" : ""} gap-6`}
        >
          <ResourceCardsSkeleton count={isMobile ? 1 : 3} />
        </div>

        {isMobile && (
          <div className="flex justify-center gap-2 mt-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                className={`h-2 ${i === 1 ? "w-6" : "w-2"} bg-gray-300 dark:bg-gray-600 rounded-full`}
                key={i}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <MainPageWrapper
      actions={<MobileFilterToggleButton onClick={() => {}} />}
      subtitle="Access and discover learning materials, documents, videos, and more"
      title="Resource Library"
    >
      {isMobile ? (
        <>
          <FeaturedResourcesSkeleton />
          <ResourceCardsSkeleton count={8} />
        </>
      ) : (
        <div className="flex flex-col md:flex-row gap-6">
          <div className="w-80 shrink-0 bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-700 overflow-y-auto p-2">
            <FilterSidebarSkeleton />
          </div>

          <div className="flex-1 min-w-0">
            <FeaturedResourcesSkeleton />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              <ResourceCardsSkeleton count={8} />
            </div>
          </div>
        </div>
      )}
    </MainPageWrapper>
  );
}
